import { loadTsToken } from "@/lib/tsIdentity";

/**
 * Trade the current TS session for a manager session.
 *
 * Deliberately not the shared `api` axios instance. That instance attaches the
 * *manager* token and, on a 401, expires the manager session and hard-navigates
 * to /login. Both are wrong here: the caller is authenticating with the TS
 * token precisely because it has no manager session yet, and on the Team host
 * there is no manager token to attach — so the request went out with no
 * Authorization header and came back "Not authenticated", then bounced the page.
 *
 * Plain fetch with an explicit TS bearer keeps the two session types from
 * bleeding into each other.
 */
export async function requestManageSession() {
  const tsToken = loadTsToken();
  if (!tsToken) {
    const err = new Error("Sign in with your phone first.");
    err.status = 401;
    throw err;
  }

  let res;
  try {
    res = await fetch("/api/ts/manage-session", {
      method: "POST",
      headers: { Authorization: `Bearer ${tsToken}` },
      // Lets the browser keep the HttpOnly handoff cookie the server sets for
      // the cross-subdomain hop.
      credentials: "include",
    });
  } catch {
    const err = new Error("Could not reach the server. Check your connection.");
    err.status = 0;
    throw err;
  }

  let body = null;
  try {
    body = await res.json();
  } catch {
    /* non-JSON error body */
  }

  if (!res.ok) {
    const err = new Error(body?.detail || "Could not open Ops.");
    err.status = res.status;
    throw err;
  }
  if (!body?.token) {
    const err = new Error("Ops session was not issued.");
    err.status = res.status;
    throw err;
  }
  return body.token;
}
